<div class="container g-0">
    <form [formGroup]="form">
        <div class="form-container">
            <div class="form-row">
                <!-- Password Field -->
                <div class="form-col">
                    <label>
                        {{ localizations.aumico_users_registration_password_label | i18next }}
                    </label>
                    <input
                        hamInput
                        type="password"
                        [placeholder]="localizations.aumico_users_registration_password_placeholder | i18next"
                        [formControl]="form.controls[password]"
                    />
                </div>

                <!-- Repeat Password Field -->
                <div class="form-col">
                    <label>
                        {{ localizations.aumico_reports_registration_welcome_repeat_password_label | i18next }}
                    </label>
                    <input
                        hamInput
                        type="password"
                        [placeholder]="localizations.aumico_users_registration_password_placeholder | i18next"
                        [formControl]="form.controls[repeatedPassword]"
                    />
                </div>
            </div>

            <!-- Password Strength Checker -->
            <div *ngIf="showPasswordConstraints" class="password-strength-container">
                <mat-password-strength
                    class="aum-password-strength"
                    #passwordComponent
                    [password]="passwordChange"
                    enableLengthRule="true"
                    min="8"
                    max="32"
                    warnThreshold="8"
                    [customValidator]="passwordValidatorRegex"
                ></mat-password-strength>

                <mat-password-strength-info
                    class="aum-password-strength-info"
                    *ngIf="form && form.controls[password]"
                    password="passwordChange"
                    [passwordComponent]="passwordComponent"
                    [lowerCaseCriteriaMsg]="'aumico_users_registration_password_lower_case_criteria_message' | i18next"
                    [upperCaseCriteriaMsg]="'aumico_users_registration_password_upper_case_criteria_message' | i18next"
                    [digitsCriteriaMsg]="'aumico_users_registration_password_digits_criteria_message' | i18next"
                    [specialCharsCriteriaMsg]="
                        'aumico_users_registration_password_special_char_criteria_message' | i18next
                    "
                    [minCharsCriteriaMsg]="'aumico_users_registration_password_min_chars_criteria_message' | i18next"
                    [customCharsCriteriaMsg]="
                        'aumico_users_registration_password_special_char_criteria_message' | i18next
                    "
                ></mat-password-strength-info>
            </div>
        </div>
    </form>
</div>
